var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5 3.99549C5.5 4.09105 5.484 4.18063 5.45201 4.26424C5.42052 4.34786 5.36669 4.4255 5.29051 4.49716L1.76724 7.81181C1.62758 7.9432 1.45287 8.00579 1.24313 7.99958C1.03389 7.99385 0.859439 7.92528 0.719777 7.79389C0.580116 7.6625 0.510285 7.49528 0.510285 7.29222C0.510285 7.08916 0.580116 6.92193 0.719777 6.79054L3.69075 3.99549L0.700732 1.18252C0.561071 1.05113 0.494288 0.886772 0.500382 0.689445C0.506984 0.492598 0.580116 0.328479 0.719777 0.197088C0.859438 0.0656967 1.03719 -2.34813e-08 1.25303 -3.2916e-08C1.46887 -4.23506e-08 1.64662 0.0656967 1.78628 0.197088L5.29051 3.49381C5.36669 3.56548 5.42052 3.64312 5.45201 3.72673C5.484 3.81035 5.5 3.89993 5.5 3.99549Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseRight);
export default __webpack_public_path__ + "static/media/collapse_right.d7046b05126a86a2918cb4202f6d1d32.svg";
export { ForwardRef as ReactComponent };